import React, {Component} from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";


const styles = theme => ({
	toastContainer: {
		position: 'absolute',
		left: '50%',
		bottom: '-10%',
		zIndex: 2000,
		opacity: 0,
		transition: 'bottom 1s cubic-bezier(.15,.9,.64,.96), opacity 1.2s ease-in-out',
	},
	toast: {
		position: 'relative',
		left: '-50%',
		background: '#6cbbff',
		padding: '10px 20px',
		borderRadius: '7px',
		cursor: 'pointer',
	},
	show: {
		bottom: '15%',
		opacity: 1,
	},
	fade: {
		opacity: 0,
		transition: 'opacity .2s ease-in-out'
	}
});


class Toast extends Component {
	state = {
		toastContainerClass: this.props.classes.toastContainer
	};

	timeoutRemoveToastFromList;
	timeoutHideToast;
	wasToastShown = false;

	componentWillMount(){
		setTimeout(() => {
			this.setState({
				toastContainerClass: [this.props.classes.toastContainer, this.props.classes.show].join(' ')
			}, () => {
				this.wasToastShown = true;
				this.hideToastTimeout(this.removeToastFromListTimeout)
			})
		}, 0)
	}

	hideToastTimeout = (onStateChangedCallback) => {
		this.timeoutHideToast = setTimeout(() => {
			this.setState({
				toastContainerClass: [
					this.props.classes.toastContainer,
					this.props.classes.show,
					this.props.classes.fade
				].join(' ')
			}, onStateChangedCallback);
		}, this.props.toast.timeout);
	};

	removeToastFromListTimeout = () => {
		this.timeoutRemoveToastFromList = setTimeout(() => {
			// debugger;
			this.props.removeToast(this.props.toast.id)
		}, 4000)
	};

	componentDidUpdate(prevProps, prevState, snapshot){
		if(this.wasToastShown && !this.timeoutRemoveToastFromList && ! this.timeoutHideToast){
			debugger;
			this.props.removeToast(this.toastId);
		}
	}

	componentWillUnmount(){
		if(this.timeoutRemoveToastFromList){
			this.props.removeToast(this.props.toast.id);
			clearTimeout(this.timeoutRemoveToastFromList);
		}
		if(this.timeoutHideToast){
			this.setState({
				toastContainerClass: [
					this.props.classes.toastContainer,
					this.props.classes.show,
					this.props.classes.fade
				].join(' ')
			});
			clearTimeout(this.timeoutHideToast);
		}
	}

	render(){
		const { classes,
			toast,
			removeToast } = this.props;

		return (
			<div className={this.state.toastContainerClass}>

				<div className={classes.toast} onClick={() => removeToast(toast.id)}>
					{toast.message}
				</div>
			</div>
		)
	}
};

Toast.propTypes = {
	toast: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		toast: PropTypes.string.isRequired,
	}).isRequired,

	removeToast: PropTypes.func.isRequired,
};


export default withStyles(styles)(Toast);
